module.exports = __webpack_public_path__ + "static/img/organilog-06.e02ad88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/organilog-06.png
// module id = 123
// module chunks = 0